import { AppBar } from '@material-ui/core';
import React from 'react'
import Configuration from '../configuration/Configuration';
import ConsumerGroup from '../consumerGroup/ConsumerGroup';
import Partitons from '../partitions/Partitons';
import Tags from '../tags/Tags';
import { useStyles } from './ModalRouteStyle';

export default function ModalRoutes() {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    return (
        <div>
            <div className={classes.root}>
                <AppBar elevation={0} position="static" color="default" className={classes.appBar}>
                    <div className={'tabsRow'}>
                        <div onClick={() => setValue(0)} className={value === 0 ? classes.selected : classes.notSelected}><p className={value !== 0 ? classes.tabHead : classes.activeTab}>Configuration</p></div>
                        <div onClick={() => setValue(1)} className={value === 1 ? classes.selected : classes.notSelected}><p className={value !== 1 ? classes.tabHead : classes.activeTab}>Partitions</p></div>
                        <div onClick={() => setValue(2)} className={value === 2 ? classes.selected : classes.notSelected}><p className={value !== 2 ? classes.tabHead : classes.activeTab}>Consumer groups</p></div>
                        <div onClick={() => setValue(3)} className={value === 3 ? classes.selected : classes.notSelected}><p className={value !== 3 ? classes.tabHead : classes.activeTab}>Tags</p></div>
                    </div>
                </AppBar>
                {
                    value === 0 ?
                        <div className={classes.tabsBodyContainer}>
                            <Configuration />
                        </div> :
                        value === 1 ?
                            <div className={classes.tabsBodyContainer}>
                                <Partitons />
                            </div>
                            :
                            value == 2 ?
                                <div className={classes.tabsBodyContainer}>
                                    <ConsumerGroup/>
                                </div>
                                :
                                value == 3 ?
                                    <div className={classes.tabsBodyContainer}>
                                        <Tags/>
                                    </div>
                                    :
                                    null
                }
            </div>
        </div>
    )
}
